module.exports = __webpack_public_path__ + "static/media/cz.c191257b.jpeg";